module.exports = __webpack_public_path__ + "static/media/vidrio.54fa76cc.png";